import React, { useState } from "react";
import { LeadViewDetailsProps } from "./lead-view-details.props";
import LeadViewDetailsView from "./lead-view-details-view/lead-view-details-view";
import LeadViewDetailsEdit from "./lead-view-details-edit/lead-view-details-edit";
import "./lead-view-details.scss";

const LeadViewDetails: React.FC<LeadViewDetailsProps> = (props: any) => {
  const {
    leadDetails,
    selectedLeadId,
    setLoading,
    viewEditOpen,
    viewFullInfoOpen,
    setViewFullInfoOpen,
    uploadedImage,
    setUploadedImage,
    uploadedImageFile,
    setUploadedImageFile,
    setRemoveImage,
    removeImage,
    fetchLeadDetails,
    onLeadNameUpdate,
    resetImageUpload,
    handleFormSubmitError,
    disableLeadStatus,
    permissions,
    isMobile,
  } = props;
  return (
    <div className="lead-list-view-details-edit-view">
      <div className="lead-list-view-details-view">
        <LeadViewDetailsView
          leadDetails={leadDetails}
          setLoading={setLoading}
          selectedLeadId={selectedLeadId}
          viewEditOpen={viewEditOpen}
          viewFullInfoOpen={viewFullInfoOpen}
          setViewFullInfoOpen={setViewFullInfoOpen}
          uploadedImage={uploadedImage}
          setUploadedImage={setUploadedImage}
          uploadedImageFile={uploadedImageFile}
          setUploadedImageFile={setUploadedImageFile}
          setRemoveImage={setRemoveImage}
          removeImage={removeImage}
          fetchLeadDetails={fetchLeadDetails}
          onLeadNameUpdate={onLeadNameUpdate}
          resetImageUpload={resetImageUpload}
          handleFormSubmitError={handleFormSubmitError}
          disableLeadStatus={disableLeadStatus}
          permissions={permissions}
          isMobile={isMobile}
        />
      </div>
    </div>
  );
};

export default LeadViewDetails;
